import {
  WSAvatar,
  WSElement,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useHistory } from "react-router-dom";
import { queriesPayers } from "@query";
import { selectorPayerDisplayName } from "../../shared/selectors/selectorPayerDisplayName";
import { WSQueries } from "../../query/WSQuery";
import { useQueryInvoice } from "../../query/payments/queries";
import { calculateLineItemsTotal } from "../utils";
import { InvoiceRecentUpdate } from "./InvoicesTable/InvoiceRecentUpdate";
import { buildInvoiceIcon } from "./InvoicesTable/buildInvoiceIcon";

type Props = { parentInvoiceId: string };

export const PayableParentInvoice: React.FC<Props> = props => {
  const history = useHistory();

  const queryInvoice = useQueryInvoice(props.parentInvoiceId);
  const queryPayer = queriesPayers.getPayer.useQuery(
    { payerId: queryInvoice.data?.clientId! },
    {
      enabled: !!queryInvoice.data?.clientId,
      retry: false
    }
  );

  return (
    <WSElement>
      <WSText.Heading5 mb="XL">Parent invoice</WSText.Heading5>
      <WSQueries
        queries={{
          queryInvoice,
          queryPayer
        }}
      >
        {({ queryInvoice: { data: invoice }, queryPayer: { data: payer } }) => {
          const payerName = selectorPayerDisplayName(payer);
          // TODO (v3-migration): no v3 secondary name

          return (
            <WSFlexBox
              wrap="nowrap"
              justify="space-between"
              alignItems="center"
              onClick={() => {
                history.push("/member/invoices/" + props.parentInvoiceId);
              }}
            >
              <WSFlexBox wrap="nowrap" alignItems="center">
                <WSAvatar.Icon {...buildInvoiceIcon(invoice)} mr="M" />
                <WSElement>
                  <WSText color="gray600">{payerName}</WSText>
                  {/* TODO (v3-migration): no v3 secondary name */}
                </WSElement>
              </WSFlexBox>

              <WSFlexBox direction="column" alignItems="flex-end">
                <WSText mb="XS" color="gray600">
                  {formatMoney(
                    calculateLineItemsTotal(invoice.lineItems),
                    invoice.currency
                  )}
                </WSText>
                <InvoiceRecentUpdate invoice={invoice} />
              </WSFlexBox>
            </WSFlexBox>
          );
        }}
      </WSQueries>
    </WSElement>
  );
};
